/* Horaires du SAV : état ouvert/fermé et réponse estimée, calculés à l'heure de Paris */
(function () {
  var C = window.MF_SAV || { days: [1, 2, 3, 4], open: 10, close: 17, delay: 24, label: 'du lundi au jeudi, de 10h à 17h' }
  var qsa = function (s) { return Array.prototype.slice.call(document.querySelectorAll(s)) }

  /* Heure de Paris, représentée comme une date « murale » en UTC pour calculer sans décalage */
  function paris(d) {
    var p = {}
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      .formatToParts(d || new Date()).forEach(function (x) { p[x.type] = x.value })
    return new Date(Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute))
  }
  function dow(x) { return x.getUTCDay() || 7 }
  function mins(x) { return x.getUTCHours() * 60 + x.getUTCMinutes() }
  function inWin(x) { return C.days.indexOf(dow(x)) > -1 && mins(x) >= C.open * 60 && mins(x) < C.close * 60 }
  function nextOpen(x) {
    var y = new Date(x.getTime())
    for (var i = 0; i < 14; i++) {
      if (C.days.indexOf(dow(y)) > -1) {
        var m = mins(y)
        if (i === 0) {
          if (m < C.open * 60) { y.setUTCHours(C.open, 0, 0, 0); return y }
          if (m < C.close * 60) return y
        } else { y.setUTCHours(C.open, 0, 0, 0); return y }
      }
      y.setUTCDate(y.getUTCDate() + 1); y.setUTCHours(0, 0, 0, 0)
    }
    return x
  }
  function lastClose(t) {
    var x = new Date(t.getTime())
    for (var i = 0; i < 14; i++) {
      if (C.days.indexOf(dow(x)) > -1) {
        var fin = new Date(x.getTime()); fin.setUTCHours(C.close, 0, 0, 0)
        if (fin <= t) return fin
      }
      x.setUTCDate(x.getUTCDate() - 1); x.setUTCHours(23, 59, 0, 0)
    }
    return t
  }
  /* 24 h après l'ouverture ; si ce moment est fermé, on répond avant la fermeture précédente (2 h de service minimum) */
  function estimate(x) {
    var w = nextOpen(x), t = null
    for (var essai = 0; essai < 3; essai++) {
      t = new Date(w.getTime() + C.delay * 3600000)
      if (inWin(t)) return t
      var f = lastClose(t)
      if (f.getTime() - w.getTime() >= 2 * 3600000) return f
      var apres = new Date(w.getTime()); apres.setUTCHours(C.close, 0, 0, 0)
      w = nextOpen(apres)
    }
    return t
  }
  function fmt(t) {
    var jours = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
    var now = paris()
    var a = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
    var b = Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate())
    var diff = Math.round((b - a) / 86400000)
    var j = diff === 0 ? "aujourd'hui" : diff === 1 ? 'demain' : jours[t.getUTCDay()]
    var mi = t.getUTCMinutes()
    return j + ' à ' + t.getUTCHours() + ' h' + (mi ? ' ' + (mi < 10 ? '0' : '') + mi : '')
  }

  window.MFHours = {
    isOpen: function () { return inWin(paris()) },
    estimate: function () { return fmt(estimate(paris())) },
    label: C.label
  }

  function fill() {
    var open = inWin(paris()), est = fmt(estimate(paris()))
    qsa('[data-sav-status]').forEach(function (el) {
      el.classList.toggle('is-open', open)
      var t = el.querySelector('.sav-status__t')
      if (t) t.textContent = (open ? 'SAV ouvert' : 'SAV fermé') + ' · réponse estimée ' + est
    })
    qsa('[data-sav-estimate]').forEach(function (el) { el.textContent = est })
  }
  fill()
  setInterval(fill, 60000)
})()
